<template>
  <gj-modal
      v-bind="$attrs"
      v-on="$listeners"
      :visible.sync="modalVisible"
      :contentStyle="{'height':'100%','overflow': 'hidden'}"
      size="table1400"
      :footer="false"
      @open="modalOpen">
    <template #header>
      <span>添加发货信息</span>
    </template>
    <template #content>
      <app-base-main
        :table-shadow="false"
        :no-padding="true"
        parentTable
        >
        <template #filter-group>
          <app-filter-group @reset="$gjReset" @query="$gjNoticeQuery">
            <gj-input
              v-model="filter.msku"
              placeholder="MSKU"
              width="180px"
              :matching.sync="filter.matchType"
            ></gj-input>
            <gj-warehouse-select
              v-model="filter.warehouseIds"
              multiple
              :self="false"
              :active="true"
              placeholder="仓库"
              width="152px"
            ></gj-warehouse-select>
            <gj-select
              v-model="filter.shipmentId"
              width="152px"
              placeholder="货件号"
              :options="options.shipmentMap"
              :loading="loading.shipment || loading.shipmentMap"
              @visible-change="visibleChange"
          ></gj-select>
          </app-filter-group>
        </template>
        <template #operate-group>
          <gj-button :disabled="noSelect" @click="supplementRecord(selectedRows)">补录</gj-button>
        </template>
        <template #table>
          <gj-table
            ref="gjTable"
            adaptParent
            :index="false"
            :loading="loading.table"
            :data="tableData"
            :columns="columns"
            :offset-height="54"
            selection
            :pagination="pagination"
            @page-change="$gjNoticeQuery">
            <template v-slot:shipmentId="{ row }">
              <span class="wid100 gj-mr8">
                <gj-tooltip :content="row.shipmentId" :textLine="1">
                  {{row.shipmentId | defaultShow}}
                </gj-tooltip>
              </span>
              <span>
                <gj-tag v-if="row.historySupplementFlag" :color="tagColors.orange" type="plain">历史补录</gj-tag>
                <gj-tag v-else :color="tagColors.green" type="plain">未补录</gj-tag>
              </span>
            </template>
            <template v-slot:shipNoteCodeList="{ row }">
              <span class="gj-mr8">{{row.shipNoteCodeArr[0] | defaultShow}}</span>
              <span v-if="row.shipNoteCodeArr.length >= 2">
                <gj-tooltip>
                  <template #content>
                    <div v-for="item in row.shipNoteCodeArr" :key="item">
                      发货单号：{{item}}
                    </div>
                  </template>
                  <i class="iconfont icona-Group284 size12"></i>
                </gj-tooltip>
              </span>
            </template>
            <template v-slot:op="{ row }">
              <gj-button type="text" :disabled="!row.supplementFlag" @click="supplementRecord([row])">补录</gj-button>
            </template>
          </gj-table>
        </template>
      </app-base-main>
    </template>
  </gj-modal>
</template>

<script>
  import { modalMixIn, queryMixin, selectionMixin } from "@/minxins";
  import { addShipSupplement, selectBoxShipment } from "@/api/finance";
  import { tagColors } from '@/components/tag/tag-colors';
  export default {
    name: "app-add-shipping-information",
    mixins: [modalMixIn, queryMixin, selectionMixin],
    data() {
      return {
        tableData: [],
        loading: {
          shipment: false,
          shipmentMap: false,
          table: false,
          confirm: false
        },
        options: {
          shipment: [],
          shipmentMap: []
        },
        filter: {
          shipmentId: null,
          warehouseIds: null,
          msku: null,
          matchType: 'like'
        },
        columns: [
          {id: 'picture', header: '图片', field: 'picture:smallImageUrl', width: '60px'},
          { id: 'msku', header: 'MSKU', field: 'msku', minWidth: '160px', overflowLine: 1, },
          { id: 'warehouseName', header: '仓库', field: 'warehouseName', minWidth: '130px', default: true },
          { id: 'shipmentId', header: '货件号', field: 'slot:shipmentId', minWidth: '200px' },
          {id: 'shipmentStatus', header: '货件状态', field: 'shipmentStatus', minWidth: '85px', default: true},
          { id: 'quantityShipped', header: '申报量', field: 'quantityShipped', minWidth: '100px' },
          { id: 'quantityReceived', header: '收货量', field: 'quantityReceived', minWidth: '100px' },
          { id: 'historyTotalShipQuantity', header: '补发量', field: 'historyTotalShipQuantity', minWidth: '100px' },
          { id: 'shipNoteCodeList', header: '发货单', field: 'slot:shipNoteCodeList', minWidth: '180px' },
          { id: 'batchTotalQuantity', header: '批次总数量', field: 'batchTotalQuantity', minWidth: '120px' },
          { id: 'totalPurchaseCost', header: '总采购成本', field: 'totalPurchaseCost', prefix: "totalPurchaseCurrencySymbol", minWidth: '125px', scale: 4 },
          { id: 'totalArrivalCost', header: '总到库成本', field: 'totalArrivalCost', prefix: "totalPurchaseCurrencySymbol", minWidth: '125px', scale: 4 },
          { id: 'op', header: '操作', field: 'slot:op', minWidth: '60px', fixed: "right"},
        ],
        tagColors
      }
    },
    created() {
      this.getSelectBoxShipment()
    },
    methods: {
      // 获取货件号options
      getSelectBoxShipment() {
        this.loading.shipment = true
        selectBoxShipment().then(data => {
          this.options.shipment = (data || []).map(e => ({
            id: e.shipmentId,
            text: e.shipmentId,
            ...e
          }))
          setTimeout(() => {
            if (!this.options.shipmentMap || this.options.shipmentMap.length == 0) {
              this.options.shipmentMap = this.options.shipment
            }
          }, 200);
        }).complete(()=> {this.loading.shipment = false})
      },
      visibleChange(type) {
        if (type) {
          this.loading.shipmentMap = true
          setTimeout(() => {
            this.options.shipmentMap = this.options.shipment
            this.loading.shipmentMap = false
          }, 100);
        }else {
          this.options.shipmentMap = []
        }
      },
      // 初始化
      $gjQueryInitParams() {
        return {
          filter: {
            shipmentId: null,
            warehouseIds: null,
            msku: null,
            matchType: 'like'
          }
        }
      },
      $gjQuery() {
        // 构造查询参数
        const params = {
          model: {
            accurateQuery: this.filter.matchType === 'exact',
            msku: this.filter.msku,
            warehouseIdList: this.filter.warehouseIds,
            shipmentIdList: this.filter.shipmentId ? [this.filter.shipmentId] : [],
          },
          ...this.queryPagination,
          ...this.querySort
        };
        // 查询
        this.loading.table = true;
        addShipSupplement(params)
          .then(data => {
            data.records.forEach(item => {
              item.shipNoteCodeArr = item.shipNoteCodeList ? item.shipNoteCodeList.split(',') : ['']
            });
            this.tableData = data.records;
            this.pagination = this.getPagination(data);
          })
          .complete(() => {
            this.loading.table = false;
          });
      },
      supplementRecord(rows) {
        if(rows.length > 50) {
          this.$gjMessage.warning("批量补录数据最多选择50条!")
          return false
        }
        let supplement = rows.filter(row => !row.supplementFlag)
                              .map(item => item.shipmentId)
        if(supplement.length > 0 && supplement.length < rows.length) {
          const modal = this.$gjCreate('gj-info-modal', {
              props: {
                  title: '温馨提示',
                  content: `货件：${supplement}不可补录,系统将自动移除!`
              },
              on: {
                  cancel: () => modal.$gjDestroy(),
                  confirm: () => {
                      this.$emit('confirm', rows.filter(row => row.supplementFlag))
                  }
              }
          })
        } else if(supplement.length > 0 && supplement.length == rows.length){
          this.$gjMessage.warning("选中货件已绑定发货单，无法补录，请选择未绑定发货单的货件!")
        } else {
          this.$emit('confirm', rows.filter(row => row.supplementFlag))
        }
      }
    }
  }
</script>

<style scoped lang="scss">
  .el-form-item{
    margin-bottom: 8px;
  }
  .wid100 {
    width: 100px;
    display: inline-block;
  }
  .add-product-btn {
    margin: 5px 0 10px;
  }
  .item-opt {
    font-size: 18px;
    color: #666666;
    i {
      cursor: pointer;
      &:first-child {
        padding-right: 25px;
      }
    }
  }
</style>
